//* 插件引入
import Konva from "konva";

//* 类型引入
import type { KonvaEventObject } from "konva/lib/Node";

export interface KonvaRenderEvt {
    evtName: string;
    evtHandler: (evt: KonvaEventObject<MouseEvent>) => void;
}

export interface KonvaRenderAttr {
    attrName: string;
    attrContext: any;
}

export interface KonvaRenderData {
    children?: KonvaRenderData[];
    height?: number;
    attrs?: KonvaRenderAttr[];
    width?: number;
    evts?: KonvaRenderEvt[];
    el: "Group" | "Path" | "Rect" | "Text";
}

export interface KonvaRenderDeepOption {
    data: KonvaRenderData[];
    deep: number;
}

//* 创建节点（递归）
export const createNode = (data: KonvaRenderData) => {
    //* 配置项生成
    const option: { [name: string]: any } = {};
    data.attrs?.forEach((attr) => {
        option[attr.attrName] = attr.attrContext;
    });

    //* 创建Konva控制器
    const control = new Konva[data.el](option);

    //* 检测是否存在children node
    if (data.el == "Group" && data.children?.length) {
        data.children?.forEach((value) => {
            (control as Konva.Group).add(createNode(value));
        });
    }

    //* 注册事件
    data.evts?.forEach((evt) => control.on(evt.evtName, evt.evtHandler));

    return control;
};

//* 创建index * deep个元素合并后的图片
export const renderDeep = async (
    index: number,
    option: KonvaRenderDeepOption,
    callBack?: (images: Konva.Group[]) => void
): Promise<Konva.Group[]> => {
    return await new Promise((resolve, reject) => {
        const config = {
            control: new Konva.Group(), //* 初始化控制器
            start: option.deep * index, //* 递归的起点
            end: option.deep * (index + 1), //* 递归的终点
        };

        //* 递归结束, 开始收束
        if (config.start >= option.data.length) return resolve([]);
        else {
            //* 终点处理
            if (config.end > option.data.length) config.end = option.data.length;

            //* 遍历添加元素
            for (let i = config.start; i < config.end; i++) {
                option.data[i] && config.control.add(createNode(option.data[i]));
            }

            //* 将元素组转化为图标
            setTimeout(async () => {
                //* 获取结果
                const result = [config.control, ...(await renderDeep(++index, option))];

                //* 回调
                callBack && callBack(result);

                //* 输出
                return resolve(result);
            }, 20);
        }
    });
};
